import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplacePipe } from './replace/replace.pipe';
import { FirstErrorPipe } from './firsterror/first-error.pipe';
import { UrlDecoderPipe } from './urlDecoder/url-decoder.pipe';



@NgModule({
  declarations: [ReplacePipe, FirstErrorPipe, UrlDecoderPipe],
  imports: [
    CommonModule,
    
  ],
  exports: [
    ReplacePipe,
    FirstErrorPipe,
    UrlDecoderPipe
  ]
})
export class PipesModule { }
